/**
 * Convert an array to map
 */
export const arrayToMap = (array: any[], keyField: string) => {
  const newMap = new Map()
  for (const arrayItem of array) {
    newMap.set(arrayItem[keyField], arrayItem)
  }
  return newMap
}

export const mapToArray = (map: Map<any, any>) => {
  const array: any[] = []
  map.forEach((value, key) => {
    array.push(value)
  })
  return array
}

// Export a function that determines if an object is empty
export const isEmpty = (obj: any) => {
  if (obj === null || obj === undefined) {
    return true
  }
  return Object.keys(obj).length === 0
}

export const letterCase = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/**
 * Returns all requested data from a service
 * @param client
 * @param serviceName
 * @param query
 */
export const getAllData = async (
  client: any,
  serviceName: string,
  query: any | object
): Promise<any> => {
  const allData: any = []
  const calls: [string, string, object][] = []
  const initialRequest = await client.service(serviceName).find({ query })
  const { total, limit, data } = initialRequest
  allData.push(...data)
  let skip = 0
  if (limit < total && !query.$limit) {
    while (skip < total) {
      skip += limit
      calls.push(['find', serviceName, { ...query, $skip: skip }])
    }
    const batchedRequest = await client.service('batch').create({ calls })
    const batchedData = handleBatchedResponse(batchedRequest)
    allData.push(...batchedData)
  }
  return allData
}

export const handleBatchedResponse = (batchedResponse: any[]) => {
  const allData: any = []
  for (const response of batchedResponse) {
    if (response.status !== 'fulfilled') {
      console.warn('Failed batch response:', response)
      throw new Error('A batched request failed.')
    }
    allData.push(...response.value.data)
  }
  return allData
}
